import { useApi } from "src/hooks/useApi";

const NONE: string[] = [];

/** Place names for a complete German PLZ (`GET /plz/:plz`, bundled GeoNames list). Cached per PLZ by
 *  useApi; nothing is requested until five digits are typed. Empty while loading or for an unknown PLZ. */
export function usePlzPlaces(plz: string): string[] {
    const valid = /^\d{5}$/.test(plz.trim());
    const { data } = useApi<{ places: string[] }>(valid ? `/plz/${plz.trim()}` : null);
    return (valid && data?.places) || NONE;
}
